import { NS } from "../../static/constants";

// ----------------

const TYPE_NAME = "META";

export const GET_LOCATIONS_$NETWORK  = `${NS}/${TYPE_NAME}/GET_LOCATIONS_$NETWORK`;
export const RESTORE_BRANCH          = `${NS}/${TYPE_NAME}/RESTORE_BRANCH`;
